import Box from '@mui/material/Box';
import {styled} from '@mui/material/styles';

export const ProductCardLEOWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  height: theme.spacing(56.375),
  backgroundColor: theme.palette.common.mds_global_color_white,
  borderRadius: theme.shape.borderRadius,
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(49.9)
  },
  '&.isSearchBoxCarousel': {
    height: '177px',
    width: '96px'
  }
}));

export const LeoImageContainer = styled(Box)(({theme}) => ({
  height: theme.spacing(25),
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  '&.isSearchBoxCarousel': {
    minHeight: '96px ',
    maxHeight: '96px',
    width: '96px',
    border: '1px solid  #E8E8E8'
  },
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(20),
    minHeight: theme.spacing(20)
  }
}));

export const LeoImageWrapper = styled(Box)(({theme}) => ({
  height: '100%',
  width: theme.spacing(25),
  position: 'relative',
  [theme.breakpoints.down('sm')]: {
    width: theme.spacing(20)
  },
  '&.isSearchBoxCarousel': {
    width: '95%',
    height: '100%'
  }
}));

export const LeoContentContainer = styled(Box)(({theme}) => ({
  flexGrow: 1,
  padding: theme.spacing(0.5, 1, 1, 1),
  textAlign: 'left',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  maxHeight: '250px',
  justifyContent: 'space-between',
  '&.isSearchBoxCarousel': {
    height: '50px',
    padding: '4px',
    background: '#FFFFFF'
  }
}));

export const LeoMiddleWrapper = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column'
}));

export const LeoProductNameWrapper = styled(Box)(({theme}) => ({
  borderBottom: `0.125px solid ${theme.palette.divider}`,
  height: theme.spacing(8.5),
  '&.isSearchBoxCarousel': {
    height: '50px',
    borderBottom: '0px'
  },
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(7.25)
  }
}));

export const LeoProductName = styled(Box)(({theme}) => ({
  color: theme.palette.grey[900],
  fontWeight: theme.typography.fontWeightBold,
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: '2',
  WebkitBoxOrient: 'vertical',
  lineHeight: theme.spacing(2.5),
  fontSize: theme.spacing(1.75),
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.5),
    lineHeight: theme.spacing(2.125)
  },
  '&.isSearchBoxCarousel': {
    fontSize: '12px'
  }
}));

export const LeoPackInfo = styled(Box)(({theme}) => ({
  color: theme.palette.grey[900],
  fontSize: theme.spacing(1.75),
  marginTop: theme.spacing(0.25),
  marginBottom: theme.spacing(0.75),
  lineHeight: theme.spacing(2.5),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.5),
    lineHeight: theme.spacing(2)
  },
  '&.isSearchBoxCarousel': {
    fontSize: '12px',
    margin: '0px',
    marginBottom: '4px'
  }
}));

export const LeoBrandContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  lineHeight: theme.spacing(1.75),
  fontSize: theme.spacing(1.5),
  marginTop: theme.spacing(0.75),
  [theme.breakpoints.down('sm')]: {
    fontSize: theme.spacing(1.25),
    lineHeight: theme.spacing(1.85)
  }
}));

export const LeoBrand = styled(Box)(({theme}) => ({
  color: theme.palette.grey[400],
  textOverflow: 'ellipsis',
  wordBreak: 'break-all',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: '1',
  WebkitBoxOrient: 'vertical',
  textTransform: 'capitalize',
  whiteSpace: 'normal'
}));

export const LeoDelivery = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.375),
  justifyContent: 'end',
  flex: '1 0 auto',
  marginLeft: theme.spacing(1)
}));

export const LeoMarketingRibbonContainer = styled(Box)(({theme}) => ({
  margin: theme.spacing(0.75, 0)
}));

export const CarouselProductCardListContainer = styled(Box)(({theme}) => ({
  width: theme.spacing(25),
  display: 'inline-flex',
  flexDirection: 'column',
  whiteSpace: 'nowrap',
  cursor: 'pointer',
  '&:not(:last-child)': {
    marginRight: theme.spacing(2)
  },

  [theme.breakpoints.down('lg')]: {
    [theme.breakpoints.down('sm')]: {
      width: theme.spacing(20.25),
      minWidth: theme.spacing(20.25)
    }
  },
  '&.isSearchBoxCarousel': {
    '&:first-child': {
      [theme.breakpoints.up('mobile')]: {
        margin: '0px 5px 0px 0px',
        minWidth: '96px',
        maxWidth: '96px'
      }
    },
    [theme.breakpoints.up('mobile')]: {
      margin: '0px 5px',
      minWidth: '96px',
      maxWidth: '96px'
    },
    [theme.breakpoints.up('tablet')]: {
      margin: '0px 5px',
      minWidth: '96px',
      maxWidth: '96px'
    },
    [theme.breakpoints.up('desktop')]: {
      margin: '0px 5px',
      minWidth: '96px',
      maxWidth: '96px'
    }
  },
  '&.compact': {
    width: theme.spacing(18),
    minWidth: theme.spacing(18)
  }
}));

export const LeoPromotionBadge = styled(Box)(({theme}) => ({
  marginBottom: theme.spacing(1.2),
  height: theme.spacing(4),
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    height: theme.spacing(3.75)
  }
}));
